import React, { useRef } from 'react';

// style imports
import "./Input.css";

const TextInput = ({ label, id, onChange, initialValue, maxLength, readOnly, pattern, 
  isNumber, notes }) => {
  // Create a ref to manage the input focus
  const inputRef = useRef(null);

  // Focus the input field when label is clicked
  const handleEditClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }    
  };

  // Handle onChange and detect when input has a value
  const handleOnChange = (e) => {
    const value = e.target.value
    if (onChange) {
      if (isNumber && !isNaN(value) ) {
        onChange(value)
      }else if (!isNumber ){
        onChange(value);
      }
    }
    
  };

  return (
    <div className="form-input" onClick={handleEditClick}>
      <input type="text" id={id} value={initialValue} 
      placeholder={label} onChange={handleOnChange} ref={inputRef} maxLength={maxLength}
      readOnly={readOnly} pattern={pattern}/>
      <label htmlFor={label}>{label} <span>{notes}</span></label>
    </div>
  );
};

export default TextInput;
